import { KpiAlertQuery } from './kpi-alert-query'

export const resolvers = [KpiAlertQuery]
